var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1113_8890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0023 12.4062C14.0172 12.4062 12.4102 14.0151 12.4102 15.9984C12.4102 17.9835 14.019 19.5906 16.0023 19.5906C17.9874 19.5906 19.5945 17.9818 19.5945 15.9984C19.5945 14.0133 17.9857 12.4062 16.0023 12.4062V12.4062ZM16.0023 18.33C14.7137 18.33 13.6707 17.2864 13.6707 15.9984C13.6707 14.7104 14.7143 13.6668 16.0023 13.6668C17.2903 13.6668 18.3339 14.7104 18.3339 15.9984C18.3345 17.2864 17.2909 18.33 16.0023 18.33V18.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8865 9.04398C17.5985 8.98389 14.4082 8.98681 13.119 9.04398C11.9862 9.09706 10.987 9.37064 10.1814 10.1762C8.83505 11.5226 9.00713 13.3367 9.00713 15.9973C9.00713 18.7203 8.85547 20.4925 10.1814 21.8184C11.533 23.1694 13.3734 22.9926 16.0025 22.9926C18.6998 22.9926 19.6308 22.9944 20.5845 22.6251C21.8813 22.1217 22.8601 20.9626 22.9558 18.8807C23.0165 17.5921 23.013 14.4025 22.9558 13.1133C22.8403 10.6557 21.5214 9.16531 18.8865 9.04398V9.04398ZM20.9252 20.9276C20.0426 21.8102 18.8182 21.7315 15.9855 21.7315C13.0689 21.7315 11.8993 21.7746 11.0459 20.9189C10.063 19.9406 10.2409 18.3697 10.2409 15.988C10.2409 12.7651 9.91013 10.444 13.1447 10.2783C13.8879 10.2521 14.1066 10.2433 15.9774 10.2433L16.0036 10.2608C19.1122 10.2608 21.5511 9.93531 21.6975 13.1693C21.7308 13.9072 21.7384 14.1289 21.7384 15.9967C21.7378 18.8796 21.7926 20.0561 20.9252 20.9276V20.9276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7369 13.1027C20.2005 13.1027 20.5763 12.7268 20.5763 12.2632C20.5763 11.7996 20.2005 11.4238 19.7369 11.4238C19.2733 11.4238 18.8975 11.7996 18.8975 12.2632C18.8975 12.7268 19.2733 13.1027 19.7369 13.1027Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1113_8890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4b1e8acd55f4bc308831a9b83aec942e.svg";
export { ForwardRef as ReactComponent };